import {
  COMPONENT_VALUE_TYPES as types,
  IMAGE_PADDING_TYPE,
  IMAGE_DISPLAY_TYPE,
  BACKGROUND_IMAGE_POSITION,
  BACKGROUND_IMAGE_SCALE,
  COMPONENT_COLOR_THEMES,
  BUTTON_TYPE,
  FONT_FAMILIES,
  FONT_SIZES,
  HORIZONTAL_POSITION,
  APP_HANDLERS,
  FONT_FAMILY_ROBOTO,
  FLEX_JUSTIFY_CONTENT_POSITION
} from 'shared/constants';

const propsSchema = [
  {
    key: 'images',
    label: 'Images',
    type: types.ARRAY,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.S3_ASSET_URL
      },
      {
        key: 'image_alt',
        label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
        type: types.TEXT
      },
      {
        key: 'dimensions',
        label: 'Image Dimensions',
        type: types.OBJECT,
        options: false,
        children: [
          {
            key: 'height',
            label: 'Height',
            type: types.TEXT
          },
          {
            key: 'width',
            label: 'Width',
            type: types.TEXT
          },
          {
            key: 'aspect_ratio',
            label: 'Aspect Ratio',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'tablet_dimensions',
        label: 'Image Dimensions (Tablet Exclusive)',
        type: types.OBJECT,
        options: false,
        children: [
          {
            key: 'height',
            label: 'Height',
            type: types.TEXT
          },
          {
            key: 'width',
            label: 'Width',
            type: types.TEXT
          },
          {
            key: 'aspect_ratio',
            label: 'Aspect Ratio',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'mobile_dimensions',
        label: 'Image Dimensions (Mobile Exclusive)',
        type: types.OBJECT,
        options: false,
        children: [
          {
            key: 'height',
            label: 'Height',
            type: types.TEXT
          },
          {
            key: 'width',
            label: 'Width',
            type: types.TEXT
          },
          {
            key: 'aspect_ratio',
            label: 'Aspect Ratio',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'flex_container',
        label: 'Flex Container',
        type: types.BOOLEAN
      },
      {
        key: 'flex_content_position',
        label: 'Flex Position',
        type: types.ENUM,
        options: FLEX_JUSTIFY_CONTENT_POSITION
      },
      {
        key: 'image_click_url',
        label: 'Image Click Url',
        type: types.TEXT
      },
      {
        key: 'zoom_effect',
        label: 'Zoom Effect on Hover',
        type: types.BOOLEAN
      },
      {
        key: 'caption',
        label: 'Caption',
        type: types.TEXT
      },
      {
        key: 'color_theme',
        label: 'Color Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXTAREA
      },
      {
        key: 'title_font',
        label: 'Title Font Family',
        type: types.ENUM,
        options: FONT_FAMILIES
      },
      {
        key: 'title_font_size',
        label: 'Title Font Size',
        type: types.ENUM,
        options: FONT_SIZES
      },
      {
        key: 'title_font_weight',
        label: 'Title Font weight',
        type: types.TEXT
      },
      {
        key: 'title_opacity',
        label: 'Title Opacity',
        type: types.TEXT
      },
      {
        key: 'title_line_height',
        label: 'Title Line Height (px)',
        type: types.TEXT
      },
      {
        key: 'content_padding_top',
        label: 'Content Top Padding',
        type: types.TEXT
      },
      {
        key: 'title_padding_left_right',
        label: 'Title Left/Right Padding',
        type: types.TEXT
      },
      {
        key: 'title_position',
        label: 'Title Position',
        type: types.ENUM,
        options: HORIZONTAL_POSITION
      },
      {
        key: 'description',
        label: 'Description',
        type: types.ARRAY,
        children: [
          {
            key: 'text',
            label: 'Text',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'button_type',
        label: 'Button Type',
        type: types.ENUM,
        options: BUTTON_TYPE
      },
      {
        key: 'buttons',
        label: 'Buttons',
        type: types.ARRAY,
        children: [
          {
            key: 'label',
            label: 'Button Label',
            type: types.TEXT
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
          {
            key: 'open_in_new_tab',
            label: 'Open in New Tab',
            type: types.BOOLEAN
          }
        ]
      },
      {
        key: 'bottom_buttons_padding',
        label: 'Bottom Buttons Padding (ex: "20px")',
        type: types.TEXT
      },
      {
        key: 'bottom_buttons_min_width',
        label: 'Bottom Buttons Min Width (ex: "80px")',
        type: types.TEXT
      },
      {
        key: 'bottom_buttons',
        label: 'Bottom Buttons',
        type: types.ARRAY,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT
          },
          {
            key: 'app_handler',
            label: 'Use App Handler',
            type: types.ENUM,
            options: APP_HANDLERS
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
          {
            key: 'open_in_new_tab',
            label: 'Open in New Tab',
            type: types.BOOLEAN
          },
          {
            key: 'launch_video',
            label: 'Launch video player',
            type: types.BOOLEAN
          },
          {
            key: 'isV2',
            label: 'Use V2 UI (event page)',
            type: types.BOOLEAN
          }
        ]
      }
    ]
  },
  {
    key: 'padding_type',
    label: 'Padding Type',
    type: types.ENUM,
    options: IMAGE_PADDING_TYPE
  },
  {
    key: 'custom_image_padding',
    label: 'Custom Image Padding (px)',
    type: types.TEXT
  },
  {
    key: 'custom_image_margin',
    label: 'Custom Image Margin (px)',
    type: types.OBJECT,
    children: [
      {
        key: 'margin_top',
        label: 'Margin Top',
        type: types.TEXT,
      },
      {
        key: 'margin_right',
        label: 'Margin Right',
        type: types.TEXT,
      },
      {
        key: 'margin_bottom',
        label: 'Margin Bottom',
        type: types.TEXT,
      },
      {
        key: 'margin_left',
        label: 'Margin Left',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'image_display_type',
    label: 'Single Image Display Type (Fixed or Adaptive)',
    type: types.ENUM,
    options: IMAGE_DISPLAY_TYPE
  },
  {
    key: 'image_flexible_position',
    label: 'Adaptive Image Position',
    type: types.ENUM,
    options: BACKGROUND_IMAGE_POSITION
  },
  {
    key: 'adaptiveImageBackgroundSize',
    label: 'Adaptive Image Background Size',
    type: types.ENUM,
    options: BACKGROUND_IMAGE_SCALE
  },
  {
    key: 'responsive_image',
    label: 'Use Responsive Image',
    type: types.BOOLEAN
  }
];

const defaultProps = {
  images: [
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-01.jpg',
      image_alt: '',
      image_click_url: '',
      zoom_effect: true,
      caption: '',
      color_theme: 'DARK',
      title: '',
      title_font: FONT_FAMILY_ROBOTO,
      title_font_size: '60px',
      title_font_weight: '400',
      title_opacity: '1',
      title_line_height: 'normal',
      content_padding_top: '30%',
      title_padding_left_right: '0px',
      title_position: 'center',
      description: [],
      buttons: [],
      button_type: 'UNDERLINE',
      bottom_buttons: []
    }
  ],
  padding_type: 'Non-FutureSight Padding',
  custom_image_padding: '0px',
  custom_image_margin: {
    margin_top: '0px',
    margin_right: '0px',
    margin_bottom: '0px',
    margin_left: '0px',
  },
  image_display_type: 'FIXED',
  image_flexible_position: 'CENTER',
  responsive_image: false
};

export default {
  title: 'Image',
  id: 'FutureSightImage',
  widgetImage: '/widgetImages/Image.png',
  basic: true,
  propsSchema,
  defaultProps
};
